import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuService } from './layout/menu/app.menu.service';
import { PrimeNG } from 'primeng/config';
import { AppComponent } from './app.component';

@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    standalone: false
})
export class AppMainComponent implements OnInit, OnDestroy {
    mobileMenuOpen = false;
    sidebarActive = true;
    sidebarStatic = true;
    menuClick: boolean;
    menuHoverActive = false;
    topbarItemClick: boolean;
    activeTopbarItem: any;
    pinActive: boolean = true;

    constructor(private menuService: MenuService, private primengConfig: PrimeNG, public app: AppComponent) { }

    ngOnInit(): void {
        window.addEventListener('resize', this.onLayoutClick.bind(this));
    }

    ngOnDestroy() {
        window.removeEventListener('resize', this.onLayoutClick.bind(this));
    }

    onLayoutClick() {
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
        }

        if (!this.menuClick) {
            this.menuHoverActive = false;
        }

        this.menuClick = false;
        this.topbarItemClick = false;
    }

    onSidebarClick($event) {
        this.menuClick = true;
    }

    onToggleMenu(event) {
        this.menuClick = true;

        if (this.sidebarActive) {
            this.sidebarStatic = !this.sidebarStatic;
        }

        event.preventDefault();
    }

    onSidebarMouseOver(event) {
        if (!this.sidebarStatic) {
            this.sidebarActive = this.isDesktop();
            setTimeout(() => {
                this.pinActive = this.isDesktop();
            }, 200);
        }
    }

    onSidebarMouseLeave($event) {
        if (!this.sidebarStatic) {
            setTimeout(() => {
                this.sidebarActive = false;
                this.pinActive = false;
            }, 250);
        }
    }

    onMenuButtonClick(event) {
        this.menuClick = true;

        if (this.isMobile()) {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        } else {
            this.sidebarStatic = !this.sidebarStatic;
            this.sidebarActive = this.sidebarStatic;
        }

        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    onRippleChange(event) {
        this.app.ripple = event.checked;
        this.primengConfig.ripple.set(event.checked);
    }

    isDesktop() {
        return window.innerWidth > 991;
    }

    isMobile() {
        return window.innerWidth <= 991;
    }
}

